var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// import { TextSizeGrowBorder } from './TextSizeGrowBorder';
import { TextSizeOverflowBorder } from './TextSizeOverflowBorder';
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
export class TextSizeBorders {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent;
    }
    /*
    @memoize
    get growBorder() {
      return new TextSizeGrowBorder(this);
    }
  */
    get overflowBorder() {
        return new TextSizeOverflowBorder(this);
    }
    saveCompareState() {
        //  this.growBorder.saveBorderStates();
    }
    get doesExceedBorder() {
        return this.overflowBorder.hasOverflow; // || this.growBorder.doesExceedBorder;
    }
    cacheAllBorders() {
        //  this.growBorder.cacheGrowBorders();
        this.overflowBorder.cacheOverflowBorders();
    }
    get allCachedBorderDomElements() {
        return this.overflowBorder.cachedOverflowBorders;
        // return uniq(this.growBorder.cachedGrowBorders.concat(this.overflowBorder.cachedOverflowBorders));
    }
}
__decorate([
    memoize
], TextSizeBorders.prototype, "overflowBorder", null);
